define("shared/utils/remove-html-literals", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = removeHtmlLiterals;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * @module Utils
   * @extends Utils
   *
   *
   * This function will remove all the html
   * elements and its content from the input string
   *
   *
   *
   * @method removeHtmlLiterals
   *
   * @param {String} text The string containing html elements.
   *
   * @returns {String} String without any html tags
   */
  function removeHtmlLiterals(text) {
    const containsTags = /<.*>.*<\/.*>/g;
    return text.replace(containsTags, '').trim();
  }
});